import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const VideoModal = (props) => {
    const { showVideo, toggleVideoModal } = props;

    return (
            <Modal
                isOpen={showVideo}
                toggle={toggleVideoModal}
                size="lg"
                centered
                className='video-modal'
            >
                <ModalHeader 
                    toggle={toggleVideoModal} 
                    className="video-responsive"
                >
                </ModalHeader>
                <ModalBody className='video-body'>
                    {!props?.showVideoOnly ?
                        <div className='text-header'>
                            <p className='title'>
                               {props?.question}
                            </p>
                            <p className='subtext'>
                                {props?.answer}
                            </p>
                        </div>
                        
                        : null
                    }

                    <iframe
                        title="Video"
                        width="100%"
                        height={!props?.isMobile ? "300px" : "180px"}
                        // height="auto"
                        style={{borderRadius: "10px", marginTop: "15px", border: "3px solid #675D5D"}}
                        src={props?.src}
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    />
                </ModalBody>
            </Modal>
    )
}

export default VideoModal